import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ShieldStar } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const { exchangeGoogleSession } = useAuth();
    const nav = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash;
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            setErr("Missing session_id");
            return;
        }
        const session_id = decodeURIComponent(m[1]);

        (async () => {
            try {
                await exchangeGoogleSession(session_id);
                window.history.replaceState({}, "", "/app");
                nav("/app", { replace: true });
            } catch (e) {
                const status = e.response?.status;
                const detail = e.response?.data;
                if (status === 202 || detail?.pending_approval) {
                    // New account created — awaiting super-admin approval
                    window.history.replaceState({}, "", "/login");
                    toast.info("Your access request was submitted. An administrator will review shortly.");
                    nav("/login", { replace: true });
                    return;
                }
                setErr(detail?.detail || "Sign-in failed");
                toast.error(detail?.detail || "Google sign-in failed");
            }
        })();
    }, [location, exchangeGoogleSession, nav]);

    return (
        <div className="min-h-screen bg-[#101012] text-white flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center space-y-4">
                <div className="mx-auto h-12 w-12 bg-primary rounded-md flex items-center justify-center">
                    <ShieldStar size={26} weight="fill" />
                </div>
                <div className="text-sm tracking-[0.35em] uppercase text-white/70">
                    {err ? "Sign-in error" : "Completing sign-in…"}
                </div>
                {err && <div className="text-primary text-sm mono">{err}</div>}
            </div>
        </div>
    );
}
